export default __webpack_public_path__ + "static/rocket_wireframe-51f18032edcc4524dc2124183d974436.png";